import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateFormData, nextStep } from '../../store/formSlice';
import { Button, Box, Text, VStack, HStack, Image, useBreakpointValue } from '@chakra-ui/react';
import StepHeader from './StepHeader';
import { Grandparent, Parent, Self } from '../../utils/Images';

const options = [
    { value: 'myself', label: 'For Myself', image: Self },
    { value: 'parent', label: 'For Parent', image: Parent },
    { value: 'grandparent', label: 'For Grandparent', image: Grandparent },
];

const SignupForStep = () => {
    const dispatch = useDispatch();
    const { formData, currentStep, totalSteps } = useSelector((state) => state.form);
    const isMobile = useBreakpointValue({ base: true, md: false });

    const handleSelection = (value) => {
        dispatch(updateFormData({ signupFor: value }));
    };

    const handleContinue = () => {
        if (formData.signupFor) {
            dispatch(nextStep());
        }
    };

    return (
        <Box maxW={{ base: '100%', md: '3xl' }} mx="auto" p={{ base: 2, md: 6 }} textAlign="center">
            <StepHeader
                title="Who are you signing up for?"
                subtitle="Who would you like to sign up?"
            />
            <VStack spacing={{ base: 4, md: 6 }} mb={{ base: 4, md: 8 }} align="stretch">
                {options.map((option) => (
                    <HStack
                        key={option.value}
                        border="1px solid"
                        borderColor='brand.500'
                        borderRadius="lg"
                        p={{ base: '12px 14px', md: '17px 20px' }}
                        spacing={4}
                        boxShadow={formData.signupFor === option.value ? 'md' : 'sm'}
                        cursor="pointer"
                        onClick={() => handleSelection(option.value)}
                        bg={formData.signupFor === option.value ? 'brand.50' : 'white'}
                        alignItems="center"
                        transition="all 0.2s"
                        w="100%"
                        maxW="100%"
                    >
                        <Image src={option.image} alt={option.label} boxSize={{ base: '48px', md: '56px' }} borderRadius="10px" objectFit="cover" />
                        <Text flex={1} textAlign="left" my="12px" fontSize={['15px', '24px']} color={["brand.500", "black"]} fontWeight="semibold">
                            {option.label}
                        </Text>
                        <Button
                            colorScheme={formData.signupFor === option.value ? 'brand' : 'gray'}
                            variant={formData.signupFor === option.value ? 'solid' : 'outline'}
                            // size={['sm', 'md']}
                            borderRadius="full"
                            px={["24px", "30px"]}
                            fontSize={["14.4px", "16px"]}
                        >
                            {formData.signupFor === option.value ? "Selected" : "Select"}
                        </Button>
                    </HStack>
                ))}
            </VStack>
            <Button
                onClick={handleContinue}
                mt={4}
                px="30px"
                isDisabled={!formData.signupFor}
            >
                Continue
            </Button>
            <Text fontSize="18px" color="gray.700" mt={6}>
                Sophie Care is here to bring joy, connection, and meaningful engagement{' '}
                <Text as="span" color="brand.500" fontSize="20px" fontWeight="semibold" display="block">
                    Every call, Every day.
                </Text>
            </Text>
        </Box>
    );
};

export default SignupForStep;
